import { render, staticRenderFns } from "./OwnerView.vue?vue&type=template&id=869ce21a"
import script from "./OwnerView.vue?vue&type=script&lang=js"
export * from "./OwnerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports